// KJUR，hextob64，b64tohex来源：jsrsasign
import CryptoJS from 'crypto-js/crypto-js'
import {
  privateKey,
  publicKey,
  begin,
  end,
  split,
  publicStr,
  rsaOption,
} from '@/constants/code-map'
const CryptoOptions = {
  mode: CryptoJS.mode.ECB,
  padding: CryptoJS.pad.Pkcs7,
}

// 从环境变量读取密钥，如果未配置则使用默认值
const keyClient = import.meta.env.VITE_CRYPTO_KEY_CLIENT
const keyServer = import.meta.env.VITE_CRYPTO_KEY_SERVER
const privateStr = import.meta.env.VITE_CRYPTO_PRIVATESTR

const genarateKey = (p, key) => {
  const splits = new Array(6).join(split)
  const content = key
  const str = `${p.toUpperCase()} KEY${splits}`
  return `${splits}${begin.toUpperCase()} ${str}${content}${splits}${end.toUpperCase()} ${str}`
}

// 加密
export function encryptionAES(params) {
  let keys = '',
    encryptorStr = ''
    console.log('🚀 ~ encryptionAES ~ keyClient:', keyClient)
  keys = md5(keyClient)
  // 开始加密
  const data = CryptoJS.enc.Utf8.parse(JSON.stringify(params))
  const encrypted = CryptoJS.AES.encrypt(data, keys, CryptoOptions)
  encryptorStr = encrypted.toString()
  //返回 加密后的 字符串
  return encryptorStr
}

// 解密
export function decryptAES(params) {
  try {
    let keys = '',
      decryptStr = ''
    keys = md5(keyServer)
    const decrypted = CryptoJS.AES.decrypt(params, keys, CryptoOptions)
    decryptStr = decrypted.toString(CryptoJS.enc.Utf8)
    //返回 解密后的 字符串
    const decryptedData = JSON.parse(decryptStr)
    return decryptedData
  } catch (e) {
    return params
  }
}

// 解密函数
export const ccbDecrypt = (ciphertext) => {
  const ccbKeyClient = 'ZGY2NjUyZGJjMGRkNDM1Mw=='
  const key = md5(ccbKeyClient)
  // 分割IV和密文
  const parts = ciphertext.split(':')
  if (parts.length !== 2) {
    return
  }
  const iv = CryptoJS.enc.Hex.parse(parts[0])
  const encrypted = parts[1]

  // 解密
  const decrypted = CryptoJS.AES.decrypt(encrypted, CryptoJS.enc.Utf8.parse(key), {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  })

  // 将解密结果转换为字符串
  return decrypted.toString(CryptoJS.enc.Utf8)
}

// md5加密key
function md5(params) {
  let keys = '',
    md5Str = ''
  keys = CryptoJS.MD5(atob(params))
  // 转16进制
  md5Str = keys.toString(CryptoJS.enc.Hex)
  // 取中间16位
  return CryptoJS.enc.Utf8.parse(md5Str.substr(md5Str.length / 2 - 8, 16))
}

export function utf8ToHex(str) {
  return Array.from(str)
    .map(c =>
      c.charCodeAt(0) < 128
        ? c.charCodeAt(0).toString(16).length == 1
          ? '0' + c.charCodeAt(0).toString(16)
          : c.charCodeAt(0).toString(16)
        : encodeURIComponent(c).replace(/\%/g, '').toLowerCase()
    )
    .join('')
}

export function hexToUtf8(hex) {
  return decodeURIComponent('%' + hex.match(/.{1,2}/g).join('%'))
}

// 签名
export function sha256WithRSA({ systemId = 2201, uuid, timestamp, versionId = '1.0' }) {
  let signStr = '',
    shaStr = ''
  signStr = systemId + uuid + timestamp + versionId
  // RSA signature generation
  const sig = new window.KJUR.crypto.Signature(rsaOption)
  // privateStr.split('/').splice(privateStr.length - 2, 0, 'K')
  const keyStr = genarateKey(privateKey, privateStr)
  sig.init(keyStr)
  sig.updateString(signStr)
  // signStr进行签名
  shaStr = sig.sign()
  // Base64编码
  return window.hextob64(shaStr)
}

// 验签
export function verify({ signStr, systemId, uuid, timestamp, versionId }) {
  const sig = new window.KJUR.crypto.Signature(rsaOption)
  sig.init(genarateKey(publicKey, publicStr, 'a'))
  const sign = systemId + uuid + timestamp + versionId
  sig.updateString(sign)
  return sig.verify(window.b64tohex(signStr))
}

// 生成uuid
export function uuid() {
  var s = []
  var hexDigits = '0123456789abcdef'
  for (var i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
  }
  s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
  s[8] = s[13] = s[18] = s[23] = '-'

  var uuid = s.join('')
  return uuid
}
